import { render, staticRenderFns } from "./SkuEdit.vue?vue&type=template&id=3b1d9200"
import script from "./SkuEdit.vue?vue&type=script&lang=js"
export * from "./SkuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports